import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
const Notification = () => {
    const navigator = useNavigate();
    return (
        <>
            <Helmet>
                <title>Notifications | TLK</title>
            </Helmet>
            {/* start: privacy page */}
            <div className="min-h-screen gradient-bg-1">
                <div className="fixed w-full top-0 bg-background/95 backdrop-blur-sm border-b border-border px-4 py-3 flex items-center gap-3 z-10">
                    <button className="text-foreground"
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-lg font-semibold text-foreground">Notifications</h1>
                </div>
                <div
                    className="p-6 pt-[100px] max-w-2xl mx-auto"
                    style={{ opacity: 1, transform: "none" }}
                >
                    <div className="space-y-6 flex flex-col">
                        {/* Item */}
                        <div className="flex justify-between items-start bg-white rounded-[10px] shadow p-3">
                            <div className="flex items-start gap-4">
                                <button className="w-6 h-6 flex flex-[0_0_auto] items-center justify-center bg-gray-200 text-gray-500 rounded">
                                    ✕
                                </button>
                                <div>
                                    <span className="inline-block bg-green-500 text-white text-xs px-2 py-1 rounded mb-2">
                                        Joined New User
                                    </span>
                                    <h2 className="font-semibold text-gray-800">
                                        New Registration: Finibus Bonorum et Malorum
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantium
                                    </p>
                                    <p className="text-sm text-red-500 mt-2 font-medium">Allen Deu</p>
                                </div>
                            </div>
                            <div className="text-[12px] text-gray-400 flex items-center gap-1 whitespace-nowrap">
                                <span>🕒</span>
                                <span>24 Nov 2018 at 9:30 AM</span>
                            </div>
                        </div>
                        {/* Item */}
                        <div className="flex justify-between items-start bg-white rounded-[10px] shadow p-3">
                            <div className="flex items-start gap-4">
                                <button className="w-6 h-6 flex flex-[0_0_auto] items-center justify-center bg-gray-200 text-gray-500 rounded">
                                    ✕
                                </button>
                                <div>
                                    <span className="inline-block bg-yellow-500 text-white text-xs px-2 py-1 rounded mb-2">
                                        Message
                                    </span>
                                    <h2 className="font-semibold text-gray-800">
                                        Darren Smith sent new message
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantium
                                    </p>
                                    <p className="text-sm text-red-500 mt-2 font-medium">Darren</p>
                                </div>
                            </div>
                            <div className="text-[12px] text-gray-400 flex items-center gap-1 whitespace-nowrap">
                                <span>🕒</span>
                                <span>24 Nov 2018 at 9:30 AM</span>
                            </div>
                        </div>
                        {/* Item */}
                        <div className="flex justify-between items-start bg-white rounded-[10px] shadow p-3">
                            <div className="flex items-start gap-4">
                                <button className="w-6 h-6 flex flex-[0_0_auto] items-center justify-center bg-gray-200 text-gray-500 rounded">
                                    ✕
                                </button>
                                <div>
                                    <span className="inline-block bg-purple-600 text-white text-xs px-2 py-1 rounded mb-2">
                                        Comment
                                    </span>
                                    <h2 className="font-semibold text-gray-800">
                                        Arin Ganshiram Commented on post
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantium
                                    </p>
                                    <p className="text-sm text-red-500 mt-2 font-medium">
                                        Arin Ganshiram
                                    </p>
                                </div>
                            </div>
                            <div className="text-[12px] text-gray-400 flex items-center gap-1 whitespace-nowrap">
                                <span>🕒</span>
                                <span>24 Nov 2018 at 9:30 AM</span>
                            </div>
                        </div>
                        {/* Item */}
                        <div className="flex justify-between items-start bg-white rounded-[10px] shadow p-3">
                            <div className="flex items-start gap-4">
                                <button className="w-6 h-6 flex flex-[0_0_auto] items-center justify-center bg-gray-200 text-gray-500 rounded">
                                    ✕
                                </button>
                                <div>
                                    <span className="inline-block bg-cyan-600 text-white text-xs px-2 py-1 rounded mb-2">
                                        Connect
                                    </span>
                                    <h2 className="font-semibold text-gray-800">
                                        Jullet Den Connect Allen Depk
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantium
                                    </p>
                                    <p className="text-sm text-red-500 mt-2 font-medium">Jullet Den</p>
                                </div>
                            </div>
                            <div className="text-[12px] text-gray-400 flex items-center gap-1 whitespace-nowrap">
                                <span>🕒</span>
                                <span>24 Nov 2018 at 9:30 AM</span>
                            </div>
                        </div>
                        {/* Item */}
                        <div className="flex justify-between items-start bg-white rounded-[10px] shadow p-3">
                            <div className="flex items-start gap-4">
                                <button className="w-6 h-6 flex flex-[0_0_auto] items-center justify-center bg-gray-200 text-gray-500 rounded">
                                    ✕
                                </button>
                                <div>
                                    <span className="inline-block bg-yellow-500 text-white text-xs px-2 py-1 rounded mb-2">
                                        Message
                                    </span>
                                    <h2 className="font-semibold text-gray-800">
                                        Darren Smith sent new message
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantium
                                    </p>
                                    <p className="text-sm text-red-500 mt-2 font-medium">Jullet Den</p>
                                </div>
                            </div>
                            <div className="text-[12px] text-gray-400 flex items-center gap-1 whitespace-nowrap">
                                <span>🕒</span>
                                <span>24 Nov 2018 at 9:30 AM</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* end: privacy page */}
        </>
    );
}

export default Notification;
